const STORAGE_KEY = 'fixe:lastPassbookId';

/** Persiste a última loja visitada para manter o menu ao sair do contexto /loja/:id. */
export function getLastPassbookId(): string | undefined {
  try {
    return sessionStorage.getItem(STORAGE_KEY) ?? undefined;
  } catch {
    return undefined;
  }
}

export function setLastPassbookId(idPassbook: string): void {
  try {
    sessionStorage.setItem(STORAGE_KEY, idPassbook);
  } catch {
    /* storage indisponível */
  }
}

export function clearLastPassbookId(): void {
  try {
    sessionStorage.removeItem(STORAGE_KEY);
  } catch {
    /* storage indisponível */
  }
}
